import { render, staticRenderFns } from "./study-participants-data-dashboard.vue?vue&type=template&id=fb5579d6&scoped=true&"
import script from "./study-participants-data-dashboard.vue?vue&type=script&lang=js&"
export * from "./study-participants-data-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./study-participants-data-dashboard.vue?vue&type=style&index=0&id=fb5579d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5579d6",
  null
  
)

component.options.__file = "study-participants-data-dashboard.vue"
export default component.exports